var exports = {
  "L": "x52a3aa3b--2c598f--navigation",
  "p": "x52a3aa3b--2c598f--list",
};

module.exports = exports;
